import { ProfileCard } from '@almbrand/profilecard';
import { useThemeName } from 'hooks/useThemeName';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store';
import { fetchCustomerDetails } from 'store/slices/customerSlice';
// import { mapCtaProps } from 'common/buttonUtils';

export interface ProfileCardComponentProps {
	editTitle: string;
	editLink: Link;
	logOutTitle: string;
	logOutLink: Link;
}

export const ProfileCardComponent: React.FC<ProfileCardComponentProps> = ({
	editTitle,
	editLink,
	logOutTitle,
	logOutLink,
}) => {
	const themeName = useThemeName();
	const dispatch = useAppDispatch();
	const customerDetails = useAppSelector((state) => state.customer.data);

	useEffect(() => {
		dispatch(fetchCustomerDetails());
	}, [dispatch]);

	useEffect(() => {
		console.log('Customer details:', customerDetails);
	}, [customerDetails]);

	return (
		<ProfileCard
			iconProps={{ themeName: themeName, icon: 'building', width: 60, height: 60 }}
			name={'CTB Transport'}
			profileInfo={[
				{ title: 'CVR', value: '12345678' },
				{ title: 'Adresse', value: 'Eksempelvej 1, 1234 By' },
				{ title: 'Telefon', value: '+45 12 34 56 78' },
				{ title: 'Email', value: 'kontakt@virksomhed.dk' },
			]}
			editButtonProps={{
				children: editTitle ?? 'Rediger information',
				buttonType: 'link',
				linkButtonSettings: {
					href: editLink?.url,
				},
				iconProps: {
					icon: 'pen',
					themeName: themeName,
				},
				iconPosition: 'right',
			}}
			logoutButtonProps={{
				children: logOutTitle ?? 'Log ud',
				buttonType: 'link',
				linkButtonSettings: {
					href: logOutLink?.url,
				},
			}}
		/>
	);
};
